import { useCallback } from "react";
import debounce from "lodash.debounce";

export default (func: any, waitMs: number) =>
  useCallback(debounce(func, waitMs), []);
